const styles = theme => ({
  container: {
    margin: '0 auto',
    display: 'flex',
    paddingTop: '16px',
    paddingBottom: '40px',
    //maxWidth: '800px',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    minHeight: 'calc(100vh - 120px)',
    transition: 'all 0.3s',
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    maxWidth: '800px',
  },
})

export default styles
